import { z } from "zod"

export class FormikValidationError extends Error {
    public name = "ValidationError"

    public inner: Array<{ path: string; message: string }> = []

    public constructor(message: string) {
        super(message)
    }
}

function createFormikValidationError(e: z.ZodError) {
    const error = new FormikValidationError(e.message)

    error.inner = e.issues.map((issue) => ({
        message: issue.message,
        path: issue.path.join("."),
    }))

    return error
}

export function createZodFormikValidationAdapter() {
    z.config(z.locales.fr())

    return <T>(
        schema: z.ZodSchema<T>,
        params?: Partial<z.core.$ZodAnyParams>
    ): { validate: (obj: T) => Promise<void> } => {
        return {
            async validate(obj: T) {
                try {
                    await schema.parseAsync(obj, params)
                } catch (err: unknown) {
                    throw createFormikValidationError(err as z.ZodError<T>)
                }
            },
        }
    }
}
